// extracted by mini-css-extract-plugin
export default {"content":"PageLayout_module-NJKDTDC4_content__8hant"};